import {
  FaCar,
  FaCut,
  FaGift,
  FaFutbol,
  FaGem,
  FaBookOpen,
  FaShoppingBasket,
  FaCouch,
  FaBriefcase,
  FaPaw,
  FaTools,
  FaDownload,
  FaPlane,
  FaMusic,
  FaSpa,
  FaMale,
  FaFemale,
  FaChild,
  FaLaptop,
  FaMobileAlt,
} from "react-icons/fa";

export const categoryConfig = {
  "Vehicles and Transportation": {
    icon: <FaCar />,
    color: "#0d6efd",
  },
  "Hair Salon Equipments": {
    icon: <FaCut />,
    color: "#d63384",
  },
  Gift: {
    icon: <FaGift />,
    color: "#dc3545",
  },
  "Sports and Toys": {
    icon: <FaFutbol />,
    color: "#198754",
  },
  "Jewelry and Watches": {
    icon: <FaGem />,
    color: "#6f42c1",
  },
  "Health and Beauty": {
    icon: <FaSpa />,
    color: "#fd7e14",
  },
  "Books and News": {
    icon: <FaBookOpen />,
    color: "#20c997",
  },
  "Groceries & Food": {
    icon: <FaShoppingBasket />,
    color: "#ffc107",
  },
  "Home & Furniture": {
    icon: <FaCouch />,
    color: "#6610f2",
  },
  "Office Supplies": {
    icon: <FaBriefcase />,
    color: "#0dcaf0",
  },
  "Pet Supplies": {
    icon: <FaPaw />,
    color: "#795548",
  },
  "Industrial & Tools": {
    icon: <FaTools />,
    color: "#6c757d",
  },
  "Digital Goods": {
    icon: <FaDownload />,
    color: "#0d6efd",
  },
  "Travel & Experiences": {
    icon: <FaPlane />,
    color: "#17a2b8",
  },
  "Music & Entertainment": {
    icon: <FaMusic />,
    color: "#e83e8c",
  },

  "Men Fashion": {
    icon: <FaMale />,
    color: "#007bff",
  },
  "Women Fashion": {
    icon: <FaFemale />,
    color: "#d63384",
  },
  "Kids and Baby Fashion": {
    icon: <FaChild />,
    color: "#fd7e14",
  },
  "Electronics and Computers": {
    icon: <FaLaptop />,
    color: "#20c997",
  },
  "Mobiles and Tablets": {
    icon: <FaMobileAlt />,
    color: "#6f42c1",
  },
};
